'use client';

import { c as _c } from "react/compiler-runtime";
import { useDialog } from '@svs/nova-foundation/nextjs/dialog';
import { ConsumerProvider } from '@svs/nova-poolbetting/core/frameworks/nextjs/components';
import type { ComponentProps, PropsWithChildren, ReactNode } from 'react';

/**
 * Event consumer provider for Powerplay, used to handle events in the application.
 *
 * @param root0 props
 * @param root0.children jsx children
 * @returns event consumer provider component
 */
export function EventConsumerProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    showDialog
  } = useDialog();
  let t1;
  if ($[0] !== showDialog) {
    t1 = {
      hasMaxCoupons() {
        return new Promise(resolve => void showDialog({
          title: "Du har maximalt antal p\xE5b\xF6rjade kuponger",
          description: "V\xE4nligen ta bort en kupong eller ers\xE4tt dessa med den nya",
          buttons: {
            primary: {
              label: "Ok",
              action: () => {
                resolve("doNothing");
              }
            },
            secondary: {
              label: "Rensa och ers\xE4tt alla kuponger",
              action: () => {
                resolve("resetAllCoupons");
              }
            }
          }
        }));
      },
      hasPopulatedCoupons() {
        return new Promise(resolve_0 => void showDialog({
          title: "Du har redan p\xE5b\xF6rjade kuponger",
          description: "Vad vill du g\xF6ra?",
          buttons: {
            primary: {
              label: "L\xE4gg till en ny kupong",
              action: () => {
                resolve_0("addNewCoupon");
              }
            },
            secondary: {
              label: "Rensa och ers\xE4tt alla kuponger",
              action: () => {
                resolve_0("resetAllCoupons");
              }
            }
          }
        }));
      }
    };
    $[0] = showDialog;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCallbackFn2 = t1;
  let t2;
  if ($[2] !== children || $[3] !== handleCallbackFn2) {
    t2 = <ConsumerProvider callbackFn={handleCallbackFn2}>{children}</ConsumerProvider>;
    $[2] = children;
    $[3] = handleCallbackFn2;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}